<app-header class="music-head"></app-header>
<div class="wrapper music-wrapper">
  <!-- <app-banner-simmer *ngIf="isLoding === true"></app-banner-simmer>
<app-banner-slider
    *ngIf="featuredData?.featured?.length > 0"
    [data]="featuredData"
  ></app-banner-slider> -->
  <section class="banner-img-sect">
    <div class="container">
      <div class="row">
        <div class="banner-img col-12">
          <img src="assets/images/music-banner.png" class="w-100" />
        </div>
      </div>
    </div>
  </section>
  <!-- <app-songs-simmer *ngIf="shimmerStatus.topSongs"></app-songs-simmer> -->
  <section class="populer-slider" *ngIf="!shimmerStatus.topSongs && songData?.length > 0">
    <div class="container">
      <div class="section-head">
        <a href="javascript:void(0)">
          <h2>{{ "MUSIC_INFO.TOP_SONGS" | translate }}</h2>
        </a>
        <a *ngIf="data?.length > 5" href="javascript:void(0)" class="text-primary view-all-link" [routerLink]="
            data.subcategoryCount > 0
              ? ['/music', data.slug]
              : ['/music-list', data.slug]
          ">
          {{ "HOME.VIEW_ALL" | translate }}
        </a>
      </div>
      <div class="row top-row">
        <div *ngFor="let data of songData" class="cus-col col-xl-2">
          <div class="song-item" [routerLink]="['/song-detail', data?.public_id]">
            <div class="item-img">
              <div class="ratio-slider ratio-1-1">
                <img src="{{ data?.thumbnails | thumbnails: 'square' }}" />
              </div>
            </div>
            <div class="slider-titles">
              <p class="sub-title" *ngIf="data?.cast_and_crew?.length > 0">
                <a class="orange-link" *ngFor="let cast of data?.cast_and_crew; let i = index">
                  <span>{{ cast.name | titlecase }}</span>
                  <span *ngIf="data?.cast_and_crew?.length !== i + 1">,&nbsp;</span>
                </a>
              </p>
              <h5 class="title">
                <a title="{{ data.name }}" href="javascript:void(0)">
                  {{ data.name }}
                </a>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <app-songs-simmer *ngIf="shimmerStatus.favoriteSongs"></app-songs-simmer> -->

  <!-- <section class="music-cate-sect">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-9 not-found-cate">
          <div class="section-head">
            <a class="mr-2" [routerLink]="
                subCategoryCount > 0
                  ? ['/music', categoryParam.slug]
                  : ['/music-list', categoryParam.slug]
              ">
              <h2>{{ categoryParam.slug | removeDash }}</h2>
            </a>
            <a *ngIf="categoryContent?.length > 5" class="orange-link font-14 ml-2" [routerLink]="
                subCategoryCount > 0
                  ? ['/music', categoryParam.slug]
                  : ['/music-list', categoryParam.slug]
              ">
              {{ "HOME.VIEW_ALL" | translate }}
            </a>
          </div>
          <div class="row" *ngIf="categoryContent.length > 0">
            <div class="col-6 col-sm-4 col-md-3 col-lg-2" *ngFor="let content of categoryContent"
              [routerLink]="content | redirectUrl">
              <div class="ratio-1-1">
                <img src="{{ content.thumbnail }}" />
              </div>
              <div class="slider-titles">
                <h5 class="title" title="Half Girlfriend">
                  {{ content.name }}
                </h5>
              </div>
            </div>
          </div>
          <div class="record-not-available" *ngIf="categoryContent.length == 0">
            <div class="text-center">
              <img src="assets/images/no-recoard-playlist.png" />
              <p class="no-recored-content">
                Oops! Looks like no songs available in this category. Please try
                another category
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-3" *ngIf="categoryData.length > 0">
          <div class="section-head">
            <h2>Choose By Category</h2>
          </div>
          <ul class="music-cate-list">
            <li *ngFor="let category of categoryData; let i = index">
              <div class="custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="category.checked"
                  [id]="'customCheck' + i" [name]="'example' + i" (click)="selectCategory(category)" />

                <label class="custom-control-label black-link font-weight-light" [for]="'customCheck' + i">
                  {{ category.name }}
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section> -->

  <section class="populer-slider" *ngIf="favoriteSongs.length > 0 && !shimmerStatus.favoriteSongs">
    <div class="container">
      <div class="section-head">
        <a href="javascript:void(0)">
          <h2>{{ "MUSIC_INFO.MY_FAVORITE_SONG" | translate }}</h2>
        </a>
        <!-- <a *ngIf="data?.length > 5" href="javascript:void(0)" class="text-primary view-all-link" [routerLink]="
            data.subcategoryCount > 0
              ? ['/music', data.slug]
              : ['/music-list', data.slug]
          ">
          {{ "HOME.VIEW_ALL" | translate }}
        </a> -->
      </div>
      <div class="row top-row">
        <div *ngFor="let data of favoriteSongs" class="cus-col col-xl-2">
          <div class="song-item" [routerLink]="['/song-detail', data?.public_id]">
            <div class="item-img">
              <div class="ratio-slider ratio-1-1">
                <img src="{{ data?.thumbnails | thumbnails: 'square' }}" />
              </div>
            </div>
            <div class="slider-titles">
              <p class="sub-title" *ngIf="data?.cast_and_crew?.length > 0">
                <span *ngFor="let cast of data?.cast_and_crew; let i = index">{{ cast.name | titlecase
                  }}<span *ngIf="data?.cast_and_crew?.length !== i + 1">,&nbsp;</span>
                </span>
              </p>
              <h5 class="title">
                <a title="{{ data?.name }}" href="javascript:void(0)">
                  {{ data?.name }}
                </a>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-music-list-simmer *ngIf="shimmerStatus.playList"></app-music-list-simmer>
  <section *ngIf="!shimmerStatus.playList && playListData.length > 0">
    <div class="container">
      <div class="section-head pr-0">
        <a href="javascript:void(0)">
          <h2>
            {{ "MUSIC_INFO.MY_PLAYLIST" | translate }}
            <a href="javasceript:void(0)" (click)="addToPlayList('')" class="
                d-flex
                align-item-center
                orange-link
                font-16
                ml-2
                d-inline-flex
              ">
              <span class="mdi mdi-text-box-plus-outline mr-2"></span>
              Create Playlist
            </a>
          </h2>
        </a>
      </div>
      <div class="populer-slider music-album">
        <owl-carousel-o [options]="topalbum">
          <ng-container>
            <ng-template carouselSlide *ngFor="let data of playListData; let i = index">
              <div class="series-box delete-content">
                <div class="ratio-slider ratio-1-1 view-content" [routerLink]="['/music-player', data.public_id]"
                  [queryParams]="{ type: 'playList' }">
                  <img src="{{ appConstant.playListImg }}" />
                </div>
                <a class="delete-icon cursor-pointer" (click)="deletePlayList(data, i)">
                  <span class="icon-close"></span>
                </a>
                <div class="slider-titles">
                  <p class="sub-title" title="{{ data.total_songs }}">{{ data.total_songs==0 || data.total_songs==1 ?
                    data.total_songs + 'Track' :data.total_songs + 'Tracks' }}</p>
                  <h5 class="title" title="{{ data.name }}">{{ data.name }}</h5>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </section>
  <app-music-list-simmer *ngIf="shimmerStatus.category"></app-music-list-simmer>
  <section *ngIf="!shimmerStatus.category && subcategory.length > 0">
    <div class="music-list" *ngFor="let data of subcategory">
      <div *ngIf="data.content.length > 0">
        <div class="container position-relative">
          <div class="section-head">
            <a [routerLink]="
                data.subcategoryCount > 0
                  ? ['/music', data.slug]
                  : ['/music-list', data.slug]
              "[queryParams]="{ type: apiParam.type }">
              <h2>{{ data | languageTranslate }}</h2>
            </a>

            <a *ngIf="data.content.length > 7" href="javascript:void(0)" class="orange-link" [routerLink]="
                data.subcategoryCount > 0
                  ? ['/music', data.slug]
                  : ['/music-list', data.slug]
              "[queryParams]="{ type: apiParam.type }">
              {{ "HOME.VIEW_ALL" | translate }}
            </a>
          </div>
          <div class="music-album">
            <owl-carousel-o [options]="topalbum">
              <ng-container>
                <ng-template carouselSlide *ngFor="let content of data.content">
                  <div class="series-box" [routerLink]="content | redirectUrl"
                    [queryParams]="{ type: 'musicDetail', slug: apiParam.type }">
                    <div class="ratio-slider ratio-1-1 view-content">
                      <img src="{{ content?.thumbnails | thumbnails: 'square' }}" />
                    </div>
                    <div class="slider-titles">
                      <h5 class="title" title="{{ content.title }}">
                        {{ content.title }}
                      </h5>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<app-footer></app-footer>